var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4211_12787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9375 1H10.875C10.1125 1 9.38123 1.31607 8.84207 1.87868C8.3029 2.44129 8 3.20435 8 4V28C8 28.7956 8.3029 29.5587 8.84207 30.1213C9.38123 30.6839 10.1125 31 10.875 31H28.125C28.8875 31 29.6188 30.6839 30.1579 30.1213C30.6971 29.5587 31 28.7956 31 28V11.5L20.9375 1Z",
    stroke: "#98A2B3",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1V12H31",
    stroke: "#98A2B3",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24.1307,
    height: 11.8304,
    rx: 2.41307,
    fill: "#0300A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86914 17.6843V16.8909H8.59712V17.6843H6.69102V23H5.77227V17.6843H3.86914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2832 16.8909L11.7449 19.2802H11.7926L13.2543 16.8909H14.3222L12.419 19.9454L14.3341 23H13.2602L11.7926 20.6434H11.7449L10.2773 23H9.20341L11.1513 19.9454L9.21534 16.8909H10.2832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9352 17.6843V16.8909H19.6631V17.6843H17.757V23H16.8383V17.6843H14.9352Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4211_12787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.f854267cf53fc76b4622bcb7a9569616.svg";
export { ForwardRef as ReactComponent };